import { Download, FileText } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { CLAIM_DOCUMENTS } from './claimsData'

/** Everything attached to the claim, whoever added it. */
export function ClaimDocuments() {
  return (
    <div className="border-ink-200 bg-surface mt-8 rounded-sm border">
      <div className="border-ink-200 flex items-center justify-between border-b px-4 py-3">
        <span className="text-sm font-bold">Documents</span>
        <span className="text-ink-400 text-xs font-medium">{CLAIM_DOCUMENTS.length} files</span>
      </div>
      {CLAIM_DOCUMENTS.map((doc) => (
        <div key={doc.name} className="border-ink-200 flex items-center gap-3 border-b px-4 py-2.5">
          <div className="bg-ink-50 text-ink-500 flex size-7.5 shrink-0 items-center justify-center rounded-sm">
            <FileText className="size-3.5" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="truncate text-sm font-semibold">{doc.name}</div>
            <div className="text-ink-400 text-xs">{doc.meta}</div>
          </div>
          <Button variant="iconOnly" size="icon-sm" aria-label={`Download ${doc.name}`}>
            <Download className="text-ink-500 size-3.5" />
          </Button>
        </div>
      ))}
      <div className="bg-ink-50 flex items-center justify-between gap-3 px-4 py-3">
        <span className="text-ink-400 text-xs">
          Add photos, estimates, or anything the adjuster has asked for.
        </span>
        <Button variant="outlineThin" size="sm">
          Upload
        </Button>
      </div>
    </div>
  )
}
